module.exports = __webpack_public_path__ + "static/media/26UNRWA20.a4c9d23b.jpg";